<template>
  <div class="empty">
    <slot> No data available </slot>
  </div>
</template>

<style scoped lang="scss">
.empty {
  margin: 100px 0;
  text-align: center;
  font-size: 1.5em;
  font-weight: 300;
  color: #868686;

  &:before,
  &:after {
    content: '-';
    margin: 0 10px;
  }
}
</style>
